<script>
import FormProduct from "@/components/admin/product/FormProduct.vue";
import DrawerComponent from "@/components/Drawer.vue";

export default {
  name: 'DrawerProduct',
  components: {DrawerComponent, FormProduct}
}
</script>

<template>
  <drawer-component title="Nouveau produit">
    <form-product @close-view="$emit('closeView')" />
  </drawer-component>
</template>
